import { Expose } from 'class-transformer'

export enum GameModeTag {
  tournament = 'tournament',
  openQuickGame = 'openQuickGame',
  default = 'default',
  practice = 'practice',
  practiceTournament = 'practiceTournament',
  threeCard = 'threeCard'
}

export enum GameType {
  openTournament = 'OpenTournament',
  privateTournament = 'PrivateTournament',
  communityTournament = 'CommunityTournament',
  privateQuickPlay = 'PrivateQuickPlay',
  openQuickGame = 'openQuickGame',
  practice = 'practice',
  practiceTournament = 'practiceTournament',
  threeCard = 'threeCard'
}

export class GameMode {
  // prettier-ignore
  constructor(
    public _tag: GameModeTag,
    public _description: string
  ) {}

  @Expose()
  public get tag() {
    return this._tag
  }

  public set tag(value) {
    this._tag = value
  }

  @Expose()
  public get description() {
    return this._description
  }

  public set description(value) {
    this._description = value
  }
}
